import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		className:"card centered:",
		position: "center",
		text: message,
		...opts
	}).showToast();
}

export default showToastify